import React, { useEffect, useState } from "react";
import "./panel.scss";
import SiteTexts from "utils/Texts";
import Table from "components/Table/Table";

interface Props {
  data: any;
  showData: boolean;
  setPageNumber: React.Dispatch<React.SetStateAction<number>>;
  changeData:()=> void
}

const SubmitedPropertyRequestMobilePage: React.FC<Props> = ({
  data,
  showData,
  setPageNumber,
  changeData
}) => {
  const SiteText = SiteTexts();

  const TableHeader = [
    "Code",
    "Date",
    "Full Name",
    "Email",
    "CellPhone",
    "Action",
  ];

  return (
    <div className="contact-request-main-parent">
      <div className="table-main-parent-content">
        <div className="data-table-parent">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <h4>{SiteText.REQUEST_PAGES.SUBMITED_PROPERTY}</h4>
          </div>
          {showData ? (
            <Table
              TableHeader={TableHeader}
              TableContent={data.data}
              TableContentName={"submitedProperty"}
              HeaderMinWidth={['50px','80px','110px','240px','130px','160px']}
              currentPage={data.page}
              totalPage={Math.ceil(data.total / data.size)}
              setPageNumber={setPageNumber}
              changeData={changeData}
            />
          ) : (
            <></>
          )}{" "}
        </div>
      </div>
    </div>
  );
};

export default SubmitedPropertyRequestMobilePage;


